import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import axios from 'axios';

const ALL_COUNTRIES = ['全部','🇯🇵 JP','🇪🇸 ES','🇨🇳 CN','🇰🇷 KR','🇮🇹 IT','🇷🇺 RU','🇺🇸 US'];
const CATEGORIES = ['全部','food','fashion','handmade','art','beauty','entertainment','outdoor'];
const CAT_NAMES = { food:'🍔 美食',fashion:'👗 时尚',handmade:'🎨 手作',art:'🖼️ 艺术',beauty:'🧴 美妆',entertainment:'🎬 娱乐',outdoor:'🏔️ 户外' };
const FLAGS = { JP:'🇯🇵',ES:'🇪🇸',FR:'🇫🇷',CN:'🇨🇳',US:'🇺🇸',KR:'🇰🇷',IT:'🇮🇹',RU:'🇷🇺' };
const CURR_SYM = { USD:'$',EUR:'€',JPY:'¥',CNY:'¥',KRW:'₩',RUB:'₽' };

function formatPrice(p, c) { return `${CURR_SYM[c]||c}${p.toLocaleString()}`; }

export default function MarketplacePage() {
  const [products, setProducts] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [country, setCountry] = useState('全部');
  const [cat, setCat] = useState('全部');
  const [search, setSearch] = useState('');
  const [cartCount, setCartCount] = useState(0);
  const [msg, setMsg] = useState('');
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    axios.get('/api/market/products').then(r => setProducts(r.data)).catch(() => {});
    if (user) axios.get('/api/market/cart').then(r => setCartCount(r.data.length)).catch(() => {});
  }, [user]);

  useEffect(() => {
    let list = [...products];
    if (country !== '全部') list = list.filter(p => p.country_code === country);
    if (cat !== '全部') list = list.filter(p => p.category === cat);
    if (search) { const q = search.toLowerCase(); list = list.filter(p => p.title.toLowerCase().includes(q) || p.description.toLowerCase().includes(q)); }
    setFiltered(list);
  }, [products, country, cat, search]);

  const addToCart = async (productId) => {
    try {
      await axios.post('/api/market/cart/add', { productId });
      setMsg('✅ 已加入购物车');
      setTimeout(() => setMsg(''), 2000);
      const r = await axios.get('/api/market/cart');
      setCartCount(r.data.length);
    } catch { setMsg('❌ 加入失败'); setTimeout(() => setMsg(''), 2000); }
  };

  return (
    <div className="page-content">
      <div className="discovery-header">
        <h2>🛒 全球好物</h2>
        <p className="subtitle">来自世界各地的特色商品，跨国直达</p>
      </div>

      {/* 统计 */}
      <div className="discovery-stats">
        <div className="stat-item"><div className="stat-number">{products.length}</div><div className="stat-label">商品</div></div>
        <div className="stat-item"><div className="stat-number">{new Set(products.map(p=>p.country_code)).size}</div><div className="stat-label">国家</div></div>
        <div className="stat-item"><div className="stat-number">{cartCount}</div><div className="stat-label">购物车</div></div>
      </div>

      {msg && <div style={{textAlign:'center',padding:'8px',margin:'8px 0',background:'rgba(74,222,128,0.15)',color:'#4ade80',borderRadius:10}}>{msg}</div>}

      {/* 搜索 */}
      <div className="discovery-filters" style={{marginBottom:12}}>
        <input className="market-search" value={search} onChange={e => setSearch(e.target.value)} placeholder="🔍 搜索商品..." />
      </div>

      {/* 国家筛选 */}
      <div className="discovery-filters">
        {ALL_COUNTRIES.map(c => (
          <button key={c} className={`filter-btn ${country===c?'active':''}`} onClick={() => setCountry(c)}>{c}</button>
        ))}
      </div>

      {/* 类别筛选 */}
      <div className="discovery-filters" style={{marginBottom:20}}>
        {CATEGORIES.map(c => (
          <button key={c} className={`filter-btn ${cat===c?'active':''}`} onClick={() => setCat(c)}>{c==='全部'?'🏷️ 全部':CAT_NAMES[c]}</button>
        ))}
      </div>

      {/* 商品网格 */}
      <div className="users-grid">
        {filtered.map(p => (
          <div key={p.id} className="product-card">
            <div className="product-image">{p.image || '📦'}</div>
            <div className="product-info">
              <div className="product-title">{p.title}</div>
              <div className="product-desc">{p.description}</div>
              <div className="product-meta">
                <span className="meta-badge">{FLAGS[p.country_code]||'🌍'} {p.country_code}</span>
                <span className="meta-badge">{CAT_NAMES[p.category] || p.category}</span>
                {p.warehouseName && <span className="meta-badge" style={{background:'rgba(74,222,128,0.1)',color:'#4ade80'}}>🏭 {p.warehouseName}</span>}
              </div>
              <div className="product-price">{formatPrice(p.price, p.currency)}</div>
              <div className="product-seller">卖家: {p.seller_name}</div>
            </div>
            <button className="btn btn-primary btn-buy" onClick={() => addToCart(p.id)}>
              🛒 加入购物车
            </button>
          </div>
        ))}
        {filtered.length === 0 && (
          <div style={{gridColumn:'1/-1',textAlign:'center',padding:40,color:'var(--text-dim)'}}>暂无匹配商品</div>
        )}
      </div>

      {/* 购物车按钮 */}
      {cartCount > 0 && (
        <div className="cart-fab" onClick={() => navigate('/marketplace/cart')}>
          🛒 {cartCount}
        </div>
      )}
    </div>
  );
}
